import { Action } from '@ngrx/store';
import {OrderHistoryParams} from '../purchase.model';

export enum PurchaseFilterActionTypes {
  LoadPurchaseFilters = '[PurchaseFilter] Load PurchaseFilters'
}

export class LoadPurchaseFilters implements Action {
  readonly type = PurchaseFilterActionTypes.LoadPurchaseFilters;
  constructor(public payload: OrderHistoryParams) {}
}


export type PurchaseFilterActions = LoadPurchaseFilters;
